import request from '@/api/request.js'
const SocietyActivityApi = {}

/**
 * 学会活动列表
 */
SocietyActivityApi.societyActivityList = param => {
  return request({
    url: '/function/news/part/list',
    method: 'GET',
    params: param
  })
}

/**
 * 新增活动
 */
SocietyActivityApi.addSocietyActivity = param => {
  return request({
    url: '/function/news',
    method: 'POST',
    data: param
  })
}

/**
 * 更新数据(编辑)
 */
SocietyActivityApi.upDateSocietyActivity = param => {
  return request({
    url: '/function/news',
    method: 'PUT',
    data: param
  })
}

/**
 * 删除图文信息
 */
SocietyActivityApi.deleteNewsById = param => {
  return request({
    url: '/function/news/remove',
    method: 'POST',
    data: param
  })
}

/**
 * 置顶一条信息
 */
SocietyActivityApi.setToTop = param => {
  return request({
    url: '/function/news/setTopOne',
    method: 'POST',
    data: param
  })
}

/**
 * 根据ID查询详情
 */
SocietyActivityApi.queryDetailById = param => {
  return request({
    url: '/function/news/idAndModule',
    method: 'GET',
    params: param
  })
}

// 列表中 发布上线一条数据
SocietyActivityApi.releaseOnLine = params => {
  return request({
    url: '/function/news/release',
    method: 'POST',
    data: params
  })
}

// 列表中 下线一条数据
SocietyActivityApi.takeDown = params => {
  return request({
    url: '/function/news/takeDown',
    method: 'POST',
    data: params
  })
}

// 上传接口
SocietyActivityApi.upLoadData = param => {
  return request({
    url: '/common/upload',
    method: 'POST',
    data: param
  })
}
export default SocietyActivityApi
